import Vue from 'vue'
import VueMasonry from 'vue-masonry-css'

export default ({ app }) => {
  Vue.use(VueMasonry, app.router)
}
